// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-container {
  position: relative;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  overflow: hidden;
}
.notfound-container .overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1;
}
.notfound-container .content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 2rem;
  max-width: 800px;
}
.notfound-container .content .title {
  font-size: 3rem;
  font-weight: 500;
}
.notfound-container .content .title .line {
  display: inline-block;
  width: 50px;
  height: 2px;
  background: #fff;
  vertical-align: middle;
  margin: 0 1rem;
}
.notfound-container .content .title .line.left-line {
  margin-left: 0;
}
.notfound-container .content .title .line.right-line {
  margin-right: 0;
}
.notfound-container .content .description {
  margin-top: 1rem;
  font-size: 1rem;
  color: #eee;
}
.notfound-container .content .home-button {
  margin-top: 2rem;
  background: #fff;
  color: #000;
  padding: 0.8rem 2rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  font-size: 0.9rem;
}
.notfound-container .content .home-button:hover {
  background: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/pages/PageNotFound/PageNotFound.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,WAAA;EACA,gBAAA;AAAF;AAEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,UAAA;AAAJ;AAGE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;AADN;AAGM;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AADR;AAGQ;EACE,cAAA;AADV;AAIQ;EACE,eAAA;AAFV;AAOI;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AALN;AAQI;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;AANN;AAQM;EACE,gBAAA;AANR","sourcesContent":[".notfound-container {\r\n  position: relative;\r\n  background-size: cover;\r\n  background-position: center;\r\n  height: 100vh;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n//   font-family: 'Georgia', serif;\r\n  color: #fff;\r\n  overflow: hidden;\r\n\r\n  .overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0, 0, 0, 0.65); \r\n    z-index: 1;\r\n  }\r\n\r\n  .content {\r\n    position: relative;\r\n    z-index: 2;\r\n    text-align: center;\r\n    padding: 2rem;\r\n    max-width: 800px;\r\n\r\n    .title {\r\n      font-size: 3rem;\r\n      font-weight: 500;\r\n\r\n      .line {\r\n        display: inline-block;\r\n        width: 50px;\r\n        height: 2px;\r\n        background: #fff;\r\n        vertical-align: middle;\r\n        margin: 0 1rem;\r\n\r\n        &.left-line {\r\n          margin-left: 0;\r\n        }\r\n\r\n        &.right-line {\r\n          margin-right: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .description {\r\n      margin-top: 1rem;\r\n      font-size: 1rem;\r\n      color: #eee;\r\n    }\r\n\r\n    .home-button {\r\n      margin-top: 2rem;\r\n      background: #fff;\r\n      color: #000;\r\n      padding: 0.8rem 2rem;\r\n      border: none;\r\n      cursor: pointer;\r\n      transition: all 0.3s ease;\r\n      text-transform: uppercase;\r\n      font-size: 0.9rem;\r\n\r\n      &:hover {\r\n        background: #ddd;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
